import React, { useState } from "react";
import "./Sidebar.css";
import myImg from "../../Assets/dip.jpg";
// import { Link, NavLink } from "react-router-dom";
import { Outlet } from "react-router-dom";
import { Link } from "react-scroll";

const Sidebar = () => {
  return (
    <>
      <Navbar></Navbar>
      <Outlet />
    </>
  );
};
const Navbar = () => {
  return (
    // ------------------

    <div class="sidebar close">
      <div class="logo-details">
        <i class="bx bxl-c-plus-plus"></i>
        <div className="profile-details">
          <img src={myImg} alt="" className="img-fluid rounded-circle"></img>
        </div>
      </div>
      <nav id="navbar">
        <ul class="nav-links">
          <li>
            <Link
              to="scroll"
              spy={true}
              smooth={true}
              offset={50}
              duration={500}
            >
              <i class="bx bx-home"></i>
              <span class="link_name">Home</span>
            </Link>

            <ul class="sub-menu blank">
              <li>
                <a class="link_name" href="#">
                  Home
                </a>
              </li>
            </ul>
          </li>
          <li>
            <Link
              to="about"
              spy={true}
              smooth={true}
              offset={50}
              duration={500}
            >
              <i class=" bx bx-user"></i>
              <span class="link_name">About</span>
            </Link>
            <ul class="sub-menu blank">
              <li>
                <a class="link_name" href="#">
                  About
                </a>
              </li>
            </ul>
          </li>

          <li>
            <Link
              to="skills"
              spy={true}
              smooth={true}
              offset={50}
              duration={500}
            >
              <i class="bx bx-book-content"></i>
              <span class="link_name">Skills</span>
            </Link>
            <ul class="sub-menu blank">
              <li>
                <a class="link_name" href="#">
                  Skills
                </a>
              </li>
            </ul>
          </li>
          <li>
            <Link
              to="services"
              spy={true}
              smooth={true}
              offset={50}
              duration={500}
            >
              <i class="bx bx-grid-alt"></i>
              <span class="link_name">Services</span>
            </Link>
            <ul class="sub-menu blank">
              <li>
                <a class="link_name">Services</a>
              </li>
            </ul>
          </li>
          <li>
            <Link
              to="resume"
              spy={true}
              smooth={true}
              offset={50}
              duration={500}
            >
              <i class="bx bx-file-blank"></i>
              <span class="link_name">Resume</span>
            </Link>
            <ul class="sub-menu blank">
              <li>
                <a
                  class="link_name"
                  target="_blank"
                  href="https://www.canva.com/design/DAFFRFZRJB4/iKal_oXvDEM5_zu5yBMo4g/view?utm_content=DAFFRFZRJB4&utm_campaign=designshare&utm_medium=link2&utm_source=sharebutton"
                >
                  Resume
                </a>
              </li>
            </ul>
          </li>
          <li>
            <Link
              to="contact"
              spy={true}
              smooth={true}
              offset={50}
              duration={500}
            >
              <i class="bx bx-envelope"></i>
              <span class="link_name">Contact</span>
            </Link>
            <ul class="sub-menu blank">
              <li>
                <a class="link_name" href="#">
                  Contact
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
    </div>

    // ----------
  );
};

export default Sidebar;
